import CalendarModal from './CalendarModal';
import ClinicModal from './ClinicModal';
import DoctorModal from './DoctorModal';
import TimeSlot from './TimeSlot';

export const getSheetContentMap = (props: any) => ({
  calendar: <CalendarModal {...props} />,
  doctor: <DoctorModal {...props} />,
  time: <TimeSlot {...props} />,
  clinic: <ClinicModal {...props} />
});
